import { useEffect, useState } from "react";
import { fetchHomeFacts } from "../api/growthOffers";

/* One request per page load, shared by every caller. */
let homeFactsRequest = null;

const loadHomeFacts = () => {
  if (!homeFactsRequest) {
    homeFactsRequest = fetchHomeFacts().catch(() => {
      homeFactsRequest = null;
      return null;
    });
  }
  return homeFactsRequest;
};

/**
 * useHomeFacts: what the server says the homepage's first screen states
 * (GET /api/growth/home-facts): the live vendor count, already rounded down
 * or null, and which button leads now. Null until known or when the read
 * fails; the banner then keeps its plain wording and its usual order.
 *
 * @returns {{ vendorCount: number|null, leadAction: string }|null}
 */
export default function useHomeFacts() {
  const [facts, setFacts] = useState(null);
  useEffect(() => {
    let active = true;
    loadHomeFacts().then((result) => {
      if (active) setFacts(result || null);
    });
    return () => {
      active = false;
    };
  }, []);
  return facts;
}
